import axios from 'axios'

/**
 * 旧 Firebase callable (httpsCallable) のエラーは `error.code` ('functions/xxx')
 * と `error.message` を持つ。呼び出し側の `.catch(e => e.code / e.message)` を
 * そのまま動かすため、AxiosError を callable 風のエラーへ変換する。
 */
export type LegacyCallableError = Error & { code?: string; details?: unknown }

const statusToCode = (status?: number): string => {
  switch (status) {
    case 400:
      return 'functions/failed-precondition'
    case 401:
      return 'functions/unauthenticated'
    case 403:
      return 'functions/permission-denied'
    case 404:
      return 'functions/not-found'
    case 409:
      return 'functions/already-exists'
    case 429:
      return 'functions/resource-exhausted'
    case 504:
      return 'functions/deadline-exceeded'
    default:
      return 'functions/internal'
  }
}

export const toLegacyCallableError = (error: unknown): LegacyCallableError => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as
      | { message?: string | string[] }
      | undefined
    const raw = data?.message
    const message = Array.isArray(raw) ? raw.join(', ') : raw ?? error.message
    const e = new Error(message) as LegacyCallableError
    e.code = statusToCode(error.response?.status)
    e.details = error.response?.data
    return e
  }
  return (
    error instanceof Error ? error : new Error(String(error))
  ) as LegacyCallableError
}
